module.exports = __webpack_public_path__ + "img/settings.4e2d0b54.svg";